import { auth, db } from './firebase'; // Adjust based on your Firebase setup
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth'; // Import from Firebase Auth
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

export const getUserProfile = async () => {
    const user = auth.currentUser;
    if (user) {
        const userDoc = await fetchUserDocument(user.uid); // Fetch user document
        return userDoc;
    }
    return null;
};

export const updateUserProfile = async (profileData) => {
    const user = auth.currentUser;
    if (user) {
        await updateUserDocument(user.uid, profileData); // Update user document
    }
};

export const sendPasswordResetEmail = async (email) => {
    await firebaseSendPasswordResetEmail(auth, email); // Use the correct function from Firebase Auth
};

export const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Create or update user document in Firestore
    await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        name: user.displayName,
        isGoogleUser: true, // Set this field to true for Google users
        // Add other fields as necessary
    }, { merge: true });
};

// Function to fetch user document from Firestore
const fetchUserDocument = async (uid) => {
    const userDocRef = doc(db, 'users', uid); // Adjust 'users' to your collection name
    const userDoc = await getDoc(userDocRef);
    return userDoc.exists() ? { id: userDoc.id, ...userDoc.data() } : null;
};

// Function to update user document in Firestore
const updateUserDocument = async (uid, profileData) => {
    const userDocRef = doc(db, 'users', uid); // Adjust 'users' to your collection name
    await setDoc(userDocRef, profileData, { merge: true }); // Merge to avoid overwriting existing data
};
